import React from 'react';
import { ClipboardList, Download, Send, Tag as TagIcon, X } from 'lucide-react';
import { Button } from '../SubscriptionAppButton';
interface ContactBulkActionsBarProps {
  count: number;
  onCreateTask: () => void;
  onAddTag: () => void;
  onExportCallList: () => void;
  onClear: () => void;
}
export function ContactBulkActionsBar({
  count,
  onCreateTask,
  onAddTag,
  onExportCallList,
  onClear
}: ContactBulkActionsBarProps) {
  return <div className="bg-white border border-[#E2E8F0] rounded-lg px-4 md:px-6 py-3 md:py-4 mb-4 md:mb-6 shadow-[0_1px_3px_rgba(15,23,42,0.08)]" role="region" aria-label="Bulk actions" data-id="element-1753" data-mp="1mz4pzwhzmzbr">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-3" data-id="element-1754" data-mp="1wq928oga462w">
        <div className="flex items-center gap-3" data-id="element-1755" data-mp="1rs7lia6bsiul">
          <span className="text-[13px] md:text-[14px] font-medium text-[#0F172A]" data-id="element-1756" data-mp="25r77tb6d8lnl">
            {count} selected
          </span>
          <button type="button" onClick={onClear} className="inline-flex items-center gap-1 text-[13px] text-[#64748B] hover:text-[#0F172A] transition-colors" data-id="element-1757" data-mp="20tf4ll09td43">
            <X className="w-3.5 h-3.5" data-id="element-1758" data-mp="36q7bs2x7hx7e" />
            Clear
          </button>
        </div>
        <div className="flex flex-wrap items-center gap-3 w-full lg:w-auto" data-id="element-1759" data-mp="36s0fb9ciw1b6">
          <Button variant="outline" size="md" iconLeft={<ClipboardList className="w-4 h-4" data-id="element-1761" data-mp="3gowhkxbtvr7a" />} onClick={onCreateTask} data-id="element-1760" data-mp="3bnz0yp6gv57w">
            Create task
          </Button>
          <Button variant="outline" size="md" iconLeft={<TagIcon className="w-4 h-4" data-id="element-1763" data-mp="3knvub43sws9a" />} onClick={onAddTag} data-id="element-1762" data-mp="3kox6xd0gtmt4">
            Add tag
          </Button>
          <Button variant="outline" size="md" iconLeft={<Download className="w-4 h-4" data-id="element-1765" data-mp="3ufi3kuwkwh9e" />} onClick={onExportCallList} data-id="element-1764" data-mp="3pmyry3hgbw78">
            Export call list
          </Button>
          <Button variant="outline" size="md" iconLeft={<Send className="w-4 h-4" data-id="element-1767" data-mp="88jufxxardri" />} data-id="element-1766" data-mp="385m0ersa1sy">
            Send to Klaviyo
          </Button>
        </div>
      </div>
    </div>;
}